/// <amd-module name="Tfs/Platform/ProjectPersona" />
import * as React from "react";
import { VssPersona, VssPersonaSize } from "VSSUI/VssPersona";

export interface IProjectPersonaProps {
    displayName: string;
    size: VssPersonaSize;
    url?: string;
}

export class ProjectPersona extends React.Component<IProjectPersonaProps> {
    public render() {
        const { displayName, size, url } = this.props;
        const identityProvider = {
            getDisplayName() {
                return displayName;
            },
            getIdentityImageUrl(size: number) {
                return url;
            }
        };
        return <VssPersona ariaLabel={null} cssClass="project-persona flex-noshrink" size={size} identityDetailsProvider={identityProvider} />;
    }
}
